import { UserService } from './user.service';

/**
 * Copies the profile fields returned by the login/redirect endpoints onto {@link UserService}.
 * Shared by the legacy-portal redirect and the email-link redirect so the two cannot drift.
 * @param userService - Service whose setters receive the values.
 * @param user - Login response user object (untyped wire payload).
 * @returns void
 */
// any: the login response is an untyped wire payload read field by field.
export function applyUserProfile(userService: UserService, user: any): void {
  userService.setRole(user.role);
  userService.setUserId(user.user_id);
  userService.setCustomerId(user.customer_id);
  userService.setComplianceProdType(user.compliance_prod_type);
  userService.setUsername(user.name);
  userService.setIsApprover(user.is_approver);
  userService.setIsLabelApplicable(user.check_label_applicable);
  userService.setRoleId(user.role_id);
  userService.setCustomerName(user.customer_name);
  userService.setInternalComplianceApplicable(user.check_internal_applicable);
  userService.setTaskApplicable(user.check_task_applicable);
  userService.setVerticalApplicable(user.check_vertical_applicable);
  userService.setHideMultiSelectChecklist(user.is_checklist_main);
  userService.setEventApplicable(user.check_event_configurable);
  userService.setAuditorStartPeriod(user.auditor_start_period);
  userService.setAuditorEndPeriod(user.auditor_end_period);
  userService.setIsUploadUsingLinkCustomer(user.is_upload_using_link_customer);
  userService.setIsHead(user.is_head);
}
